import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../../core/common/modal/ModalComponent'
import { useDeactivateUserToggleMutation, useDeleteLeadInquiryMutation, useDeleteLeadPropectMutation } from '../../../../services/EndPointsApis'
import { all_routes } from '../../../router/all_routes'

type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    setCurrentToggleState?:any
    refetch?:any
    prospectId?:any
    handleDeleteRow?:any
    showDeleteModal?:any
}



const LeadProsDeleteModal = ({ show, handleClose, data,prospectId,refetch,handleDeleteRow,showDeleteModal }: Props) => {
    const route = all_routes;
    const [deleteLeadProspect, { data: deleteData, isError, error, isSuccess }] = useDeleteLeadPropectMutation();
    const navigate = useNavigate();

    const [prospectIdState,setProspectIdState]=useState(null)

    useEffect(() => {
        if (prospectId && prospectId.length > 0) {
          const ProspectId = prospectId[0];
          setProspectIdState(ProspectId);
        }
        // if(showDeleteModal===false){
        //     refetch()
        // }
      }, [prospectId]); 

    useEffect(() => {
        if (isSuccess) {
            toast.success(deleteData?.message);
            handleClose();
            refetch()
            if (prospectIdState && handleDeleteRow) {
                handleDeleteRow(prospectIdState);  
            }
            setProspectIdState(null)         
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);

    const handelDelete=()=>{
        deleteLeadProspect({leadProspectId:prospectIdState})
    }
    return (
        <ModalComponent
            buttonText=""
            modalTitle='Delete Lead Prospect'
            onClose={handleClose}
            onSave={handelDelete}
            isVisible={show}
            cancelButton="Cancel"
            saveButton='Delete'
        >
            <>
                <p>
                    Are you sure you want to Delete Lead Propsect.
                </p>
            </>

        </ModalComponent>
    )
}

export default LeadProsDeleteModal